module.exports = __webpack_public_path__ + "static/media/xing.5c03d59c.svg";